import { env } from '@/shared/config/env';

/** API 출처 — 설정이 없으면 이 페이지와 같은 출처 */
export function apiOrigin(): string {
  return env.apiOrigin || window.location.origin;
}

/** API 절대 주소 (/api/... 경로) */
export function apiUrl(path: string): string {
  return `${apiOrigin()}${path}`;
}
